export const generateRandomNumber = () => {
  // Tạo một số ngẫu nhiên từ 1000000000 đến 9999999999 (10 chữ số)
  const randomNum = Math.floor(Math.random() * 9000000000) + 1000000000;
  return randomNum.toString(); // Chuyển số thành chuỗi
};

export const isNumeric = (numericValue) => {
  if (numericValue === 0 || numericValue === "0") return true;
  if (!numericValue) return false;
  if (typeof numericValue === "string" && numericValue.includes(",")) {
    numericValue = numericValue.replace(",", ".");
  }
  if (numericValue.endsWith(".")) return false;
  return !isNaN(numericValue) && !isNaN(parseFloat(numericValue));
};


export const showUnauthorizedPage = () => {
  // Kiểm tra xem đã hiển thị trang lỗi chưa để tránh hiển thị nhiều lần
  if (document.getElementById("unauthorized-error-page")) {
    return;
  }

  // Tạo HTML cho trang lỗi 401
  const errorPageHTML = `
    <div id="unauthorized-error-page" style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #ffffff;
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    ">
      <div style="
        text-align: center;
        padding: 40px;
        max-width: 600px;
      ">
        <div style="
          font-size: 72px;
          font-weight: 700;
          color: #dc3545;
          margin-bottom: 24px;
          line-height: 1;
        ">403</div>
        <h1 style="
          font-size: 28px;
          font-weight: 600;
          color: #212529;
          margin: 0 0 16px 0;
        ">Không có quyền truy cập</h1>
        <p style="
          font-size: 16px;
          color: #6c757d;
          margin: 0;
          line-height: 1.6;
        ">Truy cập bị từ chối. Vui lòng tắt DevTools để tiếp tục truy cập.</p>
      </div>
    </div>
  `;

  // // Xóa toàn bộ nội dung hiện tại và inject trang lỗi
  // document.body.innerHTML = errorPageHTML;

  // // Ngăn chặn mọi tương tác với trang
  // document.body.style.overflow = "hidden";
  return errorPageHTML;
};
